import { toPng } from 'html-to-image';
import { saveAs } from 'file-saver';

const EXPORT_PIXEL_RATIO = 3;
const EXPORT_BACKGROUND = '#ffffff';
const NON_ALPHANUMERIC = /[^a-z0-9]+/i;

export const isPngExportCapturable = (node: HTMLElement): boolean =>
  !(node instanceof HTMLElement && node.dataset.exportIgnore === 'true');

export const buildPngExportFileName = (
  name: string,
  fallbackName: string
): string => {
  const cleaned = name.trim().split(NON_ALPHANUMERIC).filter(Boolean).join('_');
  const baseName = cleaned || fallbackName;

  return `${baseName}_${Date.now()}`;
};

export const captureElementToPng = (element: HTMLElement): Promise<string> => {
  const { width, height } = element.getBoundingClientRect();

  return toPng(element, {
    cacheBust: true,
    pixelRatio: EXPORT_PIXEL_RATIO,
    backgroundColor: EXPORT_BACKGROUND,
    width: Math.ceil(width),
    height: Math.ceil(height),
    filter: isPngExportCapturable,
    style: {
      margin: '0',
      border: 'none',
      borderRadius: '0',
      overflow: 'visible',
    },
  });
};

export const savePngDataUrl = async (
  dataUrl: string,
  baseName: string
): Promise<void> => {
  const pngBlob = await (await fetch(dataUrl)).blob();

  saveAs(pngBlob, `${baseName}.png`);
};

export const waitForFontsReady = async (): Promise<void> => {
  await document.fonts?.ready;
};
